import React from "react";

const FloatingButton = () => {
  return (
    <>
      {/* whatsapp floating button */}
      <a className="btn-float" href="https://wa.me/9676270055" target="_blank">
        {/* <i className="fab fa-whatsapp" /> */}
        <img
          src="/images/whatsapp-white-icon.svg"
          alt="WhatsApp"
          width="25"
          height="25"
        />
      </a>
    </>
  );
};

export default FloatingButton;
